import { FormSwitch } from '@ipfabric/ui-components/FormSwitch/FormSwitch';
import { FormTextField } from '@ipfabric/ui-components/FormTextField/FormTextField';
import type { FormSnippet } from '@ipfabric/ui-components/utils/formSnippets/FormSnippet';
import { useWatch } from 'react-hook-form';
import { z } from 'zod';
import type { DiscoverySettingsObject } from '../../model/DiscoverySettingsObject';

export const scanner: FormSnippet<
  DiscoverySettingsObject,
  { shortestMask: string; scannerEnabled: boolean },
  { shortestMask: string; scannerEnabled: boolean },
  { scannerEnabledValue: boolean }
> = {
  render: ({ form, hook }) => {
    return (
      <div className='flex flex-col gap-xs'>
        <FormSwitch
          control={form.control}
          description='Use scanner in discovery'
          name='scannerEnabled'
        />
        <div className='ml-12'>
          <FormTextField
            control={form.control}
            description='Shortest mask of the network to scan'
            disabled={!hook.scannerEnabledValue}
            min={16}
            max={32}
            name='shortestMask'
            type='number'
          />
        </div>
      </div>
    );
  },
  use: ({ form }) => {
    const scannerEnabledValue = useWatch({
      control: form.control,
      name: 'scannerEnabled',
    });
    return { scannerEnabledValue };
  },
  fromModel: (model, fieldValuesDraft) => {
    fieldValuesDraft.scannerEnabled = model.scanner?.enabled ?? false;
    fieldValuesDraft.shortestMask = String(model.scanner?.shortestMask ?? 20);
  },
  toModel: (transformedValues, modelDraft) => {
    modelDraft.scanner = {
      ...modelDraft.scanner,
      enabled: transformedValues.scannerEnabled,
      shortestMask: Number.parseInt(transformedValues.shortestMask, 10),
    };
  },
  schema: z.object({
    scannerEnabled: z.boolean(),
    shortestMask: z.string().refine((val) => {
      const num = Number.parseInt(val, 10);
      return num >= 16 && num <= 32;
    }, 'Must be a number between 16 and 32'),
  }),
};
